import { render, staticRenderFns } from "./side-bar-v2.vue?vue&type=template&id=0785b463"
import script from "./side-bar-v2.vue?vue&type=script&lang=js"
export * from "./side-bar-v2.vue?vue&type=script&lang=js"
import style0 from "./side-bar-v2.vue?vue&type=style&index=0&id=0785b463&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports